<template>
  <Card
    v-if="isActive"
    tag="form"
    theme="flat"
    class="shop-floorplan-dialog-mutate-overview"
    @submit.prevent="$emit('submit')"
  >
    <template #default>
      <ButtonComponent
        v-for="(item, index) in items"
        :key="index"
        class="shop-floorplan-dialog-mutate-overview__item"
        @click="select(item)"
      >
        <span class="elder-button__label col">
          <b>{{ item.image.name }}</b>
          <span v-if="getConditionLength(item)" class="fade">{{
            $tc('xActiveConditions', getConditionLength(item), { count: getConditionLength(item) })
          }}</span>
        </span>
        <span class="elder-button__icon" :style="{ backgroundImage: `url(${item.image.url})` }"></span>
      </ButtonComponent>
      <div v-if="!value || !value.length" class="shop-floorplan-dialog-mutate-overview__no-items">
        <FontAwesomeIcon :icon="['fal', 'drafting-compass']" class="mr-1" />
        {{ $tc('noFloorplansSetup') }}
      </div>
    </template>
    <template #footer>
      <slot name="navigation" />
    </template>
  </Card>
</template>

<script>
import Card from '@/components/Card'
import { InputComponent } from 'vue-elder-input'
import { i18n } from '@/i18n'

const meta = {
  order: 1,
  id: 'overview',
  label: `${i18n.t('select')} / ${i18n.t('create')}`,
  icon: ['fal', 'list'],
}

export { meta }
export default {
  props: {
    value: Array,
    selected: Object,
    labels: Object,
    validator: Object,
    isActive: Boolean,
  },
  watch: {
    isActive: {
      handler: 'validate',
      immediate: true,
    },
  },
  computed: {
    items() {
      return this.value.filter(v => v.image)
    },
  },
  methods: {
    getConditionLength(item) {
      return [...item.conditions.if, ...item.conditions.ifnot].length
    },
    select(item) {
      this.$emit('update:selected', item)
      this.$emit('next')
    },
    validate() {
      if (!this.isActive) return
      this.$emit(
        'input',
        this.value.filter(v => v.image),
      )
    },
  },
  components: {
    Card,
    InputComponent,
  },
}
</script>

<style lang="scss">
.shop-floorplan-dialog-mutate-overview {
  max-width: 600px;
  margin: 0 auto;

  &__item {
    width: 100%;

    img {
      max-width: 175px;
    }

    .elder-button__label {
      text-align: left;
    }

    .elder-button__icon {
      $size: 100px;
      width: $size;
      height: $size;
      background-position: center;
      background-repeat: no-repeat;
      background-size: contain;
      margin: var(--vue-elder-button-padding-y, 0.75em) var(--vue-elder-button-padding-x, 1.5em);
    }

    & + & {
      margin-top: 1rem;
    }
  }

  &__no-items {
    padding: 2rem;
    border-radius: var(--border-radius);
    background-color: var(--border-color);

    text-align: center;
    opacity: 0.5;

    svg {
      filter: grayscale(100%);
    }
  }

  &__input {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: $form-gap;
  }
}
</style>
